// qc- --ga4 2022 ga4 - custom event tracking 

$(function () {
  // *************************************************************
  // GLOBAL CUSTOM EVENTS
  // *************************************************************

  // Collection page product cards - add to cart
  window.addEventListener("searchspring.domReady", (event) => {
    let globalProductGridLink = $(".product-wrap-collection a");
    let globalProductGridAtc = $(".product-wrap-collection button");

    $(globalProductGridAtc).click(function () {
      let productVariantPrice;
      let productVariant;
      let productPrice;
      let productName = $(this).closest(".product-wrap-collection").find(".product-info__caption").attr("data-ga");
      let productQuantity = $(this).closest(".shopify-product-form").find(".quantity").val();

      if ($(this).closest(".shopify-product-form").find(".product-price-only").length) {
        productVariant = "Single variant";
        productPrice = $(this).closest(".shopify-product-form").find(".product-price-only").text().replace("$", "");
      } else {
        productVariantPrice = $(this).closest(".shopify-product-form").find(".select-selected").text();
        productVariant = productVariantPrice.split("/")[1].replace("$", "").replace(/\s/g, "");
        productPrice = productVariantPrice.split("/")[0].replace("$", "").replace(/\s/g, "");
      };

      gtag("event", "add_to_cart", {
        currency: "USD",
        value: productPrice,
        items: [
          {
            item_name: productName,
            affiliation: "Sol de Janeiro Shopify",
            currency: "USD",
            item_variant: productVariant,
            quantity: productQuantity,
          },
        ],
      });
    });
  });

  // $(globalProductGridLink).click(function () {
  //   let productName = $(this).attr("data-ga");
  //   ga("send", {
  //     hitType: "event",
  //     eventCategory: "CE - Product Grid",
  //     eventAction: "click",
  //     eventLabel: productName,
  //   });
  // });

  // *************************************************************
  // HOMEPAGE CUSTOM EVENTS
  // *************************************************************
  // let homeMobileCollectionNavSlider = $(".js-mobile-category-slideshow a");
  // let homeHeroSlider = $(".homepage-slideshow a");
  // let homeSustainability = $(".section-proud a");
  // let homeVideo = $(".section-background-video a");
  // let homeBlog = $(".featured-blog-section a[data-ga]");

  // $(homeMobileCollectionNavSlider).click(function () {
  //   let collectionLinkName = $(this).attr("data-ga");
  //   ga("send", {
  //     hitType: "event",
  //     eventCategory: "CE - Homepage",
  //     eventAction: "click",
  //     eventLabel: "Mobile collection slide: " + collectionLinkName,
  //   });
  // });

  // $(homeHeroSlider).click(function () {
  //   let slideName = $(this).attr("data-ga");
  //   ga("send", {
  //     hitType: "event",
  //     eventCategory: "CE - Homepage",
  //     eventAction: "click",
  //     eventLabel: "Hero slide: " + slideName,
  //   });
  // });

  // $(document).on("click", ".section-brazilian-beauty a", function () {
  //   let linkUrl = $(this).attr("href");
  //   ga("send", {
  //     hitType: "event",
  //     eventCategory: "CE - Homepage",
  //     eventAction: "click",
  //     eventLabel: "Quote section link: " + linkUrl,
  //   });
  // }); 

  // $(homeSustainability).click(function () {
  //   ga("send", {
  //     hitType: "event",
  //     eventCategory: "CE - Homepage",
  //     eventAction: "click",
  //     eventLabel: "Sustainability icons",
  //   });
  // });

  // $(homeVideo).click(function () {
  //   ga("send", {
  //     hitType: "event",
  //     eventCategory: "CE - Homepage",
  //     eventAction: "click",
  //     eventLabel: "Our story",
  //   });
  // });

  // $(homeBlog).click(function () {
  //   let articleName = $(this).attr("data-ga");
  //   ga("send", {
  //     hitType: "event",
  //     eventCategory: "CE - Homepage",
  //     eventAction: "click",
  //     eventLabel: "Blog post: " + articleName,
  //   });
  // });

  // *************************************************************
  // BUNDLE PRODUCT qc- --bundle
  // *************************************************************
  // let bundleItemAdd = $("div.bundle-item");

  // $(bundleItemAdd).click(function () {
  //   let bundleItemAddedName = $(this).attr("data-variant-title-display");
  //   ga("send", {
  //     hitType: "event",
  //     eventCategory: "CE - Bundle Builder Action",
  //     eventAction: "add selection",
  //     eventLabel: bundleItemAddedName,
  //   });
  // });

  // $(document).on("click", ".bundle-selected-delete", function () {
  //   let bundleItemRemoveName = $(this)
  //     .parent()
  //     .find(".bundle-selected-name")
  //     .text();
  //   ga("send", {
  //     hitType: "event",
  //     eventCategory: "CE - Bundle Builder Action",
  //     eventAction: "remove selection",
  //     eventLabel: bundleItemRemoveName,
  //   });
  // });

  // $(document).on("click", "#bundle-add-checked-btn", function () {
  //   let bunddleSelectedProducts = $(this).attr("data-ga");
  //   let bunddleTotal = $(this).find(".bundle-total").text();
  //   ga("send", {
  //     hitType: "event",
  //     eventCategory: "CE - Bundle Builder Action",
  //     eventAction: "add to cart",
  //     eventLabel: "$" + bunddleTotal + " | " + bunddleSelectedProducts,
  //   });
  // });

  // *************************************************************
  // CART
  // *************************************************************
  // let productUpsell = $(".upsell-atc");

  // $(productUpsell).click(function () {
  //   let upsellName = $(this).attr("data-ga");
  //   ga("send", {
  //     hitType: "event",
  //     eventCategory: "CE - Cart Action",
  //     eventAction: "upsell add to cart",
  //     eventLabel: upsellName,
  //   });
  // });

  // $(document).on("click", ".sample-picker-btn", function () {
  //   let sampleName = $(this).attr("data-ga");
  //   ga("send", {
  //     hitType: "event",
  //     eventCategory: "CE - Cart Action",
  //     eventAction: "sample add to cart",
  //     eventLabel: sampleName,
  //   });
  // });

  // $(document).on("click", ".sample-picker span.product-minus", function () {
  //   ga("send", {
  //     hitType: "event",
  //     eventCategory: "CE - Cart Action",
  //     eventAction: "remove from cart",
  //     eventLabel: "Sample Product",
  //   });
  // });

  // $(document).on(
  //   "click",
  //   ".product-type-bundle span.product-minus",
  //   function () {
  //     ga("send", {
  //       hitType: "event",
  //       eventCategory: "CE - Cart Action",
  //       eventAction: "remove from cart",
  //       eventLabel: "Bundle Product",
  //     });
  //   }
  // );

  // *************************************************************
  // PRODUCT PAGE
  // *************************************************************
  if ($("body").hasClass("product-description-bottom")) {
    let productPageItemName = $("h1.product_name").text();
    let productPagePrice = $(".prod-details .shopify-product-form .prod-price-wrap.hide-extra-price .qc-product-price.current_price span.money").text().replace("$", "");
    let productPageVariant = $(".prod-details .shopify-product-form .swatch_options input:checked").val();
    if (productPageVariant === undefined) {
      productPageVariant = "Single variant";
    } ;
    
    // product page view event on load
    gtag("event", "view_item", {
      currency: "USD",
      value: productPagePrice,
      items: [
        {
          item_name: productPageItemName,
          affiliation: "Sol de Janeiro Shopify",
          currency: "USD",
          item_variant: productPageVariant,
          price: productPagePrice,
        },
      ],
    });

    // add to cart form submit
    $(document).on("click", ".prod-details .shopify-product-form .add_to_cart", function () {
      let productQuantity = $(this).closest(".shopify-product-form").find(".quantity").val();
      let productPrice = $(this).closest(".shopify-product-form").find(".prod-price-wrap.hide-extra-price .qc-product-price.current_price span.money").text().replace("$", "");
      let productVariant = $(this).closest(".shopify-product-form").find(".swatch-element[aria-selected='true']").attr("data-value");
      if (productVariant === undefined) {
        productVariant = "Single variant";
      } ;

      gtag("event", "add_to_cart", {
        currency: "USD",
        value: productPrice,
        items: [
          {
            item_name: productPageItemName,
            affiliation: "Sol de Janeiro Shopify",
            currency: "USD",
            item_variant: productVariant,
            quantity: productQuantity,
          },
        ],
      });
    });

    // gallery arrow
    // $(document).on("click", ".product_gallery .flickity-prev-next-button", function () {
    //   ga("send", {
    //     hitType: "event",
    //     eventCategory: eventCategory,
    //     eventAction: "gallery slide change",
    //     eventLabel: "Gallery arrow click",
    //   });
    // });

    // gallery thumbnail
    // $(document).on("click", ".gallery-cell > img", function () {
    //   let imageNumber = $(this).attr("data-index");
    //   ga("send", {
    //     hitType: "event",
    //     eventCategory: eventCategory,
    //     eventAction: "gallery slide change",
    //     eventLabel: "Gallery thumbnail click: " + imageNumber,
    //   });
    // });

    // change variant
    // $(document).on("click", ".swatch-element", function () {
    //   let variantSelection = $(this).attr("data-value");
    //   ga("send", {
    //     hitType: "event",
    //     eventCategory: eventCategory,
    //     eventAction: "click",
    //     eventLabel: "Variant selection click: " + variantSelection,
    //   });
    // });

    // accordions
    // $(document).on("click", ".product-accordion-title", function () {
    //   let accordionTitle = $(this).text();
    //   ga("send", {
    //     hitType: "event",
    //     eventCategory: eventCategory,
    //     eventAction: "accordion click",
    //     eventLabel: "Accordion click: " + accordionTitle,
    //   });
    // });

    // qty change
    // $(document).on("click", ".prod-details .purchase-details__quantity .js-change-quantity", function () {
    //   let productQuantity = $(this).parent().find(".quantity").val();
    //   ga("send", {
    //     hitType: "event",
    //     eventCategory: eventCategory,
    //     eventAction: "click",
    //     eventLabel: "Quantity change: " + productQuantity,
    //   });
    // });

  };
});